import { createSlice } from "@reduxjs/toolkit";

interface h5ConfigStore {
  isH5: boolean;
  isShowSwitchChain: boolean;
}

const initialState: h5ConfigStore = {
  isH5: true,
  isShowSwitchChain: false,
};
const h5ConfigStore = createSlice({
  name: "h5Config",
  initialState,
  reducers: {
    isH5Handler(state) {
      state.isH5 = true;
    },
    isShowSwitchChainHandler(state, action) {
      state.isShowSwitchChain = action.payload;
    },
  },
});

export const { isH5Handler, isShowSwitchChainHandler } = h5ConfigStore.actions;

export default h5ConfigStore.reducer;
